import i18n from '../../i18n';
import type { SaveContext } from '../../data/saveDestination';
import { showContentModal } from '../ui/Modal';
import { type SaveMode, SaveToSharePointDialog } from './SaveToSharePointDialog';

/** Opens the picker for one generated document, starting where the template and the user's access point. */
export function showSaveToSharePointModal(context: SaveContext, mode: SaveMode, onSaved?: () => void): void {
  showContentModal({
    title: i18n.t(mode === 'sharepoint' ? 'sharePoint.save.titleSharePoint' : 'sharePoint.save.title'),
    body: <SaveToSharePointDialog context={context} mode={mode} onSaved={onSaved} />,
    size: 'wide'
  });
}
